<template>
  <CreateForm
    v-if="creating"
    :opportunity="opportunity"
  />

  <EditForm
    v-else
    :opportunity="opportunity"
  />
</template>

<script>
import AccountLead from '@/plugins/sdk/resources/Account/Lead'
import CreateForm from '@/components/Application/Sales/Opportunities/Opportunity/Form/Create'
import EditForm from '@/components/Application/Sales/Opportunities/Opportunity/Form/Edit'

export default {
  components: {
    CreateForm,
    EditForm
  },
  props: {
    opportunity: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof AccountLead
      }
    }
  },
  data () {
    return {
      creating: false
    }
  },
  created () {
    this.creating = typeof this.opportunity.id === 'undefined'
  }
}
</script>
